<!--
  新旧服务兼容分流入口，不是业务功能实现页。
  与 APP 一致：仅登录协商的 apiLevel 达标时进入 modern 分支；旧服务或未确认能力走 legacy。
  legacy-* 为冻结兼容页面，新功能只维护 modern-*；禁止交叉同步新版 UI、搜索、筛选和分页。
  不得移除旧分支，也不得通过业务接口失败/404 探测版本或擅自提升兼容级别。
-->
<template><div class="follow-compat-shell" :key="scope + ':' + modern"><keep-alive><component :is="modern ? 'Modern' : 'Legacy'"/></keep-alive></div></template>
<script>
import Modern from '@/components/content/contro-view/modern-home-change-scene'
import Legacy from '@/components/content/contro-view/legacy-home-change-scene'
import { getControlDataInvalidationScopeKey } from '@/common/control-data-invalidation'
import { getServerApiLevelState } from '@/common/compatibility/server-api-level'
export default {
  components: { Modern, Legacy },
  data() {
    return { modern: getServerApiLevelState(this).useModernFollowManagement, scope: getControlDataInvalidationScopeKey(this) }
  },
  activated() {
    this.modern = getServerApiLevelState(this).useModernFollowManagement
    this.scope = getControlDataInvalidationScopeKey(this)
  }
}
</script>

<style scoped>.follow-compat-shell { height: 100%; min-height: 0; }</style>
